import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import Layout from '../../components/Knowledge/Layout';
import Contact from '../Contact';
import TermsAndConditions from '../TermsAndConditions';
import HowToBuy from './HowToBuy';
import ReturnsAndRefunds from './ReturnsAndRefunds';

const Knowledge = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div className="knowledge">
            <Layout>
                <Routes>
                    <Route path="/*" element={<HowToBuy />}></Route>
                    <Route path="returns-and-refunds" element={<ReturnsAndRefunds />}></Route>
                    <Route path="contact-us" element={<Contact />}></Route>
                    <Route path="terms-and-conditions" element={<TermsAndConditions />}></Route>
                </Routes>
            </Layout>
        </div>
    );
};

export default Knowledge;